import { Component } from '@angular/core';
import { BannerComponent } from '../components/banner/banner.component';
import { FormComponent } from '../components/form/form.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AppService } from '../services/app.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [BannerComponent, FormComponent, TranslatePipe],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {

  private $appData: Subscription;
  data: any = {};

  constructor(private apiService: ApiService, private appService: AppService) {
    this.$appData = this.apiService.$appData.subscribe(data => { this.applyValues(data); });
  }

  applyValues(res: any) {
    this.data = res;
    this.appService.addClickEvent()
  }

  ngAfterContentInit(){
    const data = this.apiService.getData();
    this.applyValues(data);
    this.appService.addClickEvent()
  }
}
